import { AfterViewInit, Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { findElementByBlockId } from '@shared/helpers/ui-helpers';

@Directive({
    selector: '[parentStyleEmpty]',
    standalone: false
})
export class ParentStyleEmptyDirective implements AfterViewInit {
  /* The id parent styles to remove */
  @Input('parentStyleEmpty') uid: string;

  constructor(private el: ElementRef, private renderer: Renderer2) {
  }

  ngAfterViewInit(): void {
    const {element} = findElementByBlockId(this.el, this.uid);
    this.renderer.removeClass(element, this.uid);
    this.renderer.setStyle(element, 'width', '100%');
  }
}
